import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_base_url } from "config";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const Logout = () => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const performLogout = async () => {
      try {
        const refreshToken = localStorage.getItem("refresh_token");
        
        if (!refreshToken) {
          // Se não há token, apenas limpe e redirecione
          cleanupAndRedirect();
          return;
        }
        
        // Tente fazer logout na API
        const url = api_base_url + "/dashboard/logout/";
        await axios.post(
          url,
          {
            refresh_token: refreshToken,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem("access_token")}`
            },
          }
        );
        
        setStatus('success');
        
        // Limpe tokens e redirecione
        cleanupAndRedirect();
      } catch (error) {
        console.error("Erro no logout:", error);
        setStatus('error');
        
        // Mesmo com erro, limpamos os tokens locais e redirecionamos
        cleanupAndRedirect();
      }
    };
    
    const cleanupAndRedirect = () => {
      // Limpe os tokens
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      
      // Limpe o cabeçalho de autorização
      delete axios.defaults.headers.common["Authorization"];
      
      // Redirecione após breve pausa
      setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
    };
    
    performLogout();
  }, []);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        bgcolor: 'background.paper'
      }}
    >
      {status === 'loading' && (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Encerrando sua sessão...
          </Typography>
        </>
      )}
      
      {status === 'success' && (
        <Typography variant="h6" color="success.main">
          Logout realizado com sucesso! Redirecionando...
        </Typography>
      )}
      
      {status === 'error' && (
        <Typography variant="h6" color="error.main">
          Houve um problema no logout, mas você será redirecionado...
        </Typography>
      )}
    </Box>
  );
};